import type { ReactNode } from "react";
import cx from "classnames";

import { Paragraph } from "common/ui/Paragraph";

import styles from "./Tooltip.module.scss";

interface Props {
  children: ReactNode,
  className?: string,
}

export function Tooltip({
  children,
  className,
}: Props) {
  return (
    <div className={cx(styles.Tooltip, className)}>
      <div className={styles.Pointer} />
      <div className={styles.Content}>
        {typeof children === "string" || typeof children === "number" ? (
          <Paragraph variant="p1">
            {children}
          </Paragraph>
        ) : children}
      </div>
    </div>
  )
}

